module.exports = __webpack_public_path__ + "static/img/wxImg.350d033.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/turn/wxImg.png
// module id = HTJo
// module chunks = 0